<header
    class="shiksha-dashboard-subtitle-header"
    [class.shiksha-dashboard-subtitle-header--no-divider]="!showDivider()"
    [attr.data-icon-variant]="iconVariant()"
>
    <div class="shiksha-dashboard-subtitle-header__left">
        <span class="shiksha-dashboard-subtitle-header__icon-wrap" aria-hidden="true">
            @if (iconName(); as icon) {
                <app-svg-icon
                    class="shiksha-dashboard-subtitle-header__icon"
                    [name]="icon"
                    [size]="iconSize()"
                />
            }
            <ng-content select=".shiksha-dashboard-subtitle-header__icon"></ng-content>
        </span>
        <div class="shiksha-dashboard-subtitle-header__copy">
            <h2 class="shiksha-dashboard-subtitle-header__title">{{ title() }}</h2>
        </div>
    </div>

    @if (showInfo() && subtitle(); as infoText) {
        <span
            class="shiksha-dashboard-subtitle-header__info"
            tabindex="0"
            [attr.aria-label]="infoText"
            role="note"
        >
            <span class="shiksha-dashboard-subtitle-header__info-icon" aria-hidden="true">{{
                subtitleHeaderUi.infoBadgeChar
            }}</span>
            <span class="shiksha-dashboard-subtitle-header__info-text">{{ infoText }}</span>
        </span>
    }

    @if (rightTitle() || rightSubtitle()) {
        <div class="shiksha-dashboard-subtitle-header__right">
            @if (rightTitle(); as rTitle) {
                <p class="shiksha-dashboard-subtitle-header__right-title">{{ rTitle }}</p>
            }
            @if (rightSubtitle(); as rSubtitle) {
                <p class="shiksha-dashboard-subtitle-header__right-subtitle">{{ rSubtitle }}</p>
            }
        </div>
    }
</header>
